// extracted by mini-css-extract-plugin
var _1 = "PostSectionTitleFilterMenu-module__animateUploadProgressBarWidth--bWdyo";
var _2 = "PostSectionTitleFilterMenu-module__animatedBackground--FDESF";
var _3 = "PostSectionTitleFilterMenu-module__container--j64oW";
var _4 = "PostSectionTitleFilterMenu-module__filterCount--B4KNJ";
var _5 = "PostSectionTitleFilterMenu-module__roleButton--jrPEu";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "filterCount", _5 as "roleButton" }
